import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Radio, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import { ReplaceMode } from '../types';
import styles from './style.module.less';
const ReplaceModeRadio = ({ value, onChange, disabled = false, tooltip, }) => {
    return (_jsxs("div", { className: styles.wrapper, role: "presentation", onMouseDown: (e) => e.preventDefault(), children: [_jsx(Form.Item, { children: _jsx(Radio.Group, { className: styles.radioGroup, size: "small", value: value, onChange: (e) => onChange(e.target.value), options: [
                        { label: txt('replaceCurrentOccurrence'), value: ReplaceMode.current },
                        { label: txt('replaceAllOccurrences'), value: ReplaceMode.everywhere },
                    ], disabled: disabled }) }), tooltip !== undefined && (_jsx(Tooltip, { title: tooltip, children: _jsx(QuestionCircleOutlined, { className: styles.tooltipIcon }) }))] }));
};
export default ReplaceModeRadio;
